module.exports = __webpack_public_path__ + "img/img5.a6a94a92.png";